import React from "react";

import { Paper, Grid, Typography, Divider } from "@material-ui/core";
import { withTheme, withStyles } from "@material-ui/core/styles";

import { FormattedMessage, PublishedComponent, FormPanel } from "@openimis/fe-core";

const styles = (theme) => ({
  paper: theme.paper.paper,
  title: theme.paper.title,
  item: theme.paper.item,
});

class InsureeSecondServicePointPanel extends FormPanel {
  render() {
    const { classes, updateAttribute, readOnly, edited } = this.props;
    console.log("Milues", this.props.modulesManager);

    let isInsureeFirstServicePointRequired = this.props.modulesManager.getConf(
      "fe-insuree",
      "insureeForm.isInsureeFirstServicePointRequired",
      false,
    );
    return (
      <Grid container>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography className={classes.title}>
              <FormattedMessage module="insuree" id="insuree.ASP.title" />
            </Typography>
            <Divider />
            <Grid container item xs={12} className={classes.item}>
              {readOnly && !edited.healthFacility ? (
                <FormattedMessage module="insuree" id="insuree.ASP.title" />
              ) : (
                <PublishedComponent
                  pubRef="location.DetailedHealthFacility"
                  value={edited?.secondaryHealthFacility ?? null}
                  readOnly={readOnly}
                  required={isInsureeFirstServicePointRequired}
                  onChange={(hf) => updateAttribute("secondaryHealthFacility", hf)}
                  ignoreLocation={true}
                />
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default withTheme(withStyles(styles)(InsureeSecondServicePointPanel));
